import { Injectable, TransferState, inject, makeStateKey } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GraphQLFetcher {
  private http = inject(HttpClient);
  private transferState = inject(TransferState);

  async fetch(url: string, options: RequestInit): Promise<any> {
    const body = options.body;
    const method = options.method || 'POST';

    const keyStr = `${url}::${options.body}`;
    const key = makeStateKey<string>(`GQL_${this.hashCode(keyStr)}`);

    // SSR: if it's in transfer state, return it
    if (this.transferState.hasKey(key)) {
      const cached = this.transferState.get(key, '');
      return cached;
    }

    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      ...(options.headers as any),
    });

    const response = await firstValueFrom(
      this.http.request(method, url, {
        body,
        headers,
        responseType: 'json',
        observe: 'response',
        withCredentials: false,
      })
    );

    this.transferState.set(key, response.body || '');

    var contentType = response.headers.get('content-type') || '';

    if (contentType.indexOf('application/json') > -1) {
      return response.body;
    }

    return { text: response.body };
  }

  hashCode(str: string) {
    var hash = 0,
      i,
      chr;
    if (str.length === 0) return hash;
    for (i = 0; i < str.length; i++) {
      chr = str.charCodeAt(i);
      hash = (hash << 5) - hash + chr;
      hash |= 0; // Convert to 32bit integer
    }
    return hash;
  }
}
